import { render, staticRenderFns } from "./BoardsIframe.vue?vue&type=template&id=bab3a318&"
import script from "./BoardsIframe.vue?vue&type=script&lang=ts&"
export * from "./BoardsIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports